import { render, staticRenderFns } from "./ShareRx.vue?vue&type=template&id=8bfd15ba&scoped=true&"
import script from "./ShareRx.vue?vue&type=script&lang=js&"
export * from "./ShareRx.vue?vue&type=script&lang=js&"
import style0 from "./ShareRx.vue?vue&type=style&index=0&id=8bfd15ba&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfd15ba",
  null
  
)

export default component.exports